import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EcoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"eco"}/>
}
